import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class AlarmsApi extends ModelWithFacilityApi {
    constructor(token, clientId, onUnauthorized){
        super(token, clientId, onUnauthorized)
        this.baseUrl = this.getBaseUrl() + 'alarms/'
    }

    async acknowledgeAlarm(id, comments, onSuccess, onError) {
        this.Post(id + "acknowledge/", comments, onSuccess, onError)
    }
}